import { getDatabase, ref, push } from "firebase/database";

/**
 * Work history feeds the admin activity dashboard, so only admin work belongs
 * there. Admin identity reaches this app through the deep link query params
 * (?cid=&cname=) handled in Login; a customer signing in on their own never
 * has it, and their rows used to land in the dashboard as "Unknown".
 */
export const WORKHISTORY_PATH = "map/info/workhistory";

export function isAdminSession() {
  return Boolean(
    localStorage.getItem("admin_id") && localStorage.getItem("admin_name")
  );
}

/**
 * The deep link leaves the admin identity in localStorage for good, so a
 * customer signing in afterwards on the same browser would inherit it and
 * have their work credited to that admin. Drop it whenever a non-admin
 * session starts or any session ends.
 */
export function clearAdminSession() {
  localStorage.removeItem("admin_id");
  localStorage.removeItem("admin_name");
}

/** Writes one work history row, skipping customer sessions. */
export function pushWorkHistory(entry, path = WORKHISTORY_PATH) {
  if (!isAdminSession()) return Promise.resolve(null);
  const db = getDatabase();
  return push(ref(db, path), {
    ...entry,
    id: localStorage.getItem("admin_id"),
    name: localStorage.getItem("admin_name"),
  });
}
